let loadingInstance = null as any

const start = () => {
  // For now, just return a dummy object to prevent errors
  // The actual loading functionality needs to be reimplemented
  // without using ElLoading
  if (!loadingInstance) {
    loadingInstance = {
      close: () => {
        loadingInstance = null
      }
    }
  }
  return loadingInstance
}

const close = () => {
  if (loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}

export const useFullscreenLoading = () => {
  return {
    start,
    close,
    stop: close
  }
}
